var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgDinteroIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0000FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18677 23.6016L9.18677 8.39866L10.6413 8.39866L16.7504 8.39866C17.7479 8.39866 18.7356 8.59512 19.6571 8.97684C20.5787 9.35856 21.416 9.91805 22.1213 10.6234C22.8267 11.3287 23.3861 12.166 23.7679 13.0876C24.1496 14.0091 24.346 14.9968 24.346 15.9943C24.346 16.9918 24.1496 17.9795 23.7679 18.901C23.3861 19.8226 22.8266 20.6599 22.1213 21.3652C21.416 22.0705 20.5787 22.63 19.6571 23.0117C18.7356 23.3935 17.7479 23.5899 16.7504 23.5899L10.6413 23.5899",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinteroIcon);
export default __webpack_public_path__ + "static/media/dintero-icon.bbb85fe16fd7ead5d644b734d4a0e982.svg";
export { ForwardRef as ReactComponent };